declare namespace $ {

	export class $mol_icon_playlist_remove extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=remove.view.tree.d.ts.map